import gql from "graphql-tag"

export const ALL_BONUS_PROVIDERS = gql`
  query getBonusConfigs {
    getBonusConfigs {
      id
    }
  }
`
